import {Component, EventEmitter, Input, OnInit, forwardRef} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, NG_VALUE_ACCESSOR} from "@angular/forms";
import {BehaviorSubject, combineLatest, forkJoin, Observable, of, Subject} from "rxjs";
import {EvkOption} from "@evomatik/evk-common";
import {CatalogosService} from "../../../../services/catalogos.service";
import {filter, map, startWith} from "rxjs/operators";
import { EvkDateInputComponent } from '@evomatik/evk-forms/lib/components/evk-date-input/evk-date-input.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
@Component({
    selector: 'lib-datos-beneficiario',
    templateUrl: './datos-beneficiario.component.html',
    styleUrls: ['./datos-beneficiario.component.css'],
})
export class DatosBeneficiarioComponent implements OnInit {
    @Input()
    form: FormGroup;

    tipoOptions: EvkOption[] = [];
    tipoFilteredOptions$: Observable<EvkOption[]>;
    sexoOptions: EvkOption[] = [];
    sexoFilteredOptions$: Observable<EvkOption[]>;
    estadoOptions: EvkOption[] = [];
    estadoFilteredOptions$: Observable<EvkOption[]>;
    ocupacionOptions: EvkOption[] = [];
    ocupacionFilteredOptions$: Observable<EvkOption[]>;
    etniaOptions: EvkOption[] = [];
    etniaFilteredOptions$: Observable<EvkOption[]>;
    poblacionOptions: EvkOption[] = [];
    poblacionFilteredOptions$: Observable<EvkOption[]>;
    insPoblacionOptions: EvkOption[] = [];
    insPoblacionFilteredOptions$: Observable<EvkOption[]>;

    institucion = false;

    catalogosCargados: EventEmitter<boolean> = new EventEmitter();
    @Input()
    cambioTipoBeneficiario: EventEmitter<string> = new EventEmitter();

    constructor(
        public catalogoService: CatalogosService
    ) {
    }

    ngOnInit(): void {
        this.onTipoSelected(this.form.controls.a4TipoBeneficiario);
        this.cargaCatalogos();
        this.eventHandlerEventInit();
    }

    cargaCatalogos() {
        const requests = [];
        requests.push(this.catalogoService.getByDiscriminatorSimpleOptions('TIPO-BENEFICARIO'));
        requests.push(this.catalogoService.getByDiscriminatorSimpleOptions('TIPO-POBLACION'));
        requests.push(this.catalogoService.getByDiscriminatorSimpleOptions('SEXO'));
        requests.push(this.catalogoService.getByDiscriminatorSimpleOptions('ESTADO-CIVIL'));
        requests.push(this.catalogoService.getByDiscriminatorSimpleOptions('OCUPACION'));
        requests.push(this.catalogoService.getByDiscriminatorSimpleOptions('ETNIA'));
        requests.push(this.catalogoService.getByDiscriminatorSimpleOptions('TIPO-POBLACION'));
        forkJoin(requests).subscribe((
            [res1, res2, res3, res4, res5, res6, res7]:
                [EvkOption[], EvkOption[], EvkOption[], EvkOption[], EvkOption[], EvkOption[], EvkOption[]]
        ) => {
            this.tipoOptions = res1;
            this.poblacionOptions = res2;
            this.sexoOptions = res3;
            this.estadoOptions = res4;
            this.ocupacionOptions = res5;
            this.etniaOptions = res6;
            this.insPoblacionOptions = res7;
            this.catalogosCargados.emit(true);
        });
    }

    onTipoSelected(tipo) {
        console.log('Tipo: ', tipo);
        this.cambioTipoBeneficiario.emit(tipo?.value)
        if (tipo.value && tipo.value.value === '2') {
            this.institucion = true;
        } else {
            this.institucion = false;
        }
    }

    eventHandlerEventInit() {
        this.catalogosCargados.subscribe((res) => {
            if (res) {
                this.tipoFilteredOptions$ = this.filterOptions(this.form.controls.a4TipoBeneficiario, of(this.tipoOptions));
                this.poblacionFilteredOptions$ = this.filterOptions(this.form.controls.a4TipoPoblacionBeneficiario, of(this.poblacionOptions));
                this.sexoFilteredOptions$ = this.filterOptions(this.form.controls.a4SexoBeneficiario, of(this.sexoOptions));
                this.estadoFilteredOptions$ = this.filterOptions(this.form.controls.a4EstadoCivilBeneficiario, of(this.estadoOptions));
                this.ocupacionFilteredOptions$ = this.filterOptions(this.form.controls.a4OcupacionBeneficiario, of(this.ocupacionOptions));
                this.etniaFilteredOptions$ = this.filterOptions(this.form.controls.a4EtniaBeneficiario, of(this.etniaOptions));
                this.insPoblacionFilteredOptions$ = this.filterOptions(this.form.controls.a4RTipoPoblacionInst, of(this.insPoblacionOptions));
            }
        });
        this.form.controls.a4FechaNacimientoBeneficiario.setValue(this.form.controls.a4FechaNacimientoBeneficiario.value);
    }

    filterOptions = (formControl: FormControl | AbstractControl, opciones$: Observable<EvkOption[]>, valueChanges?: Observable<any> | Subject<any> | BehaviorSubject<any>) => {
        const valueChanges$ = valueChanges ? valueChanges : formControl.valueChanges;
        return combineLatest(
            [
                valueChanges$.pipe(startWith('')),
                opciones$
            ]
        ).pipe(
            filter(([value, _]) => typeof value === 'string'
            ),
            map(([name, opciones]) => name ? this._filter(name, opciones) : opciones.slice())
        );

    }

    _filter(label: string, options: EvkOption[]): EvkOption[] {
        const filterValue = this.removeAccents(label.toLowerCase());
        return options.filter(
            option =>
                this.removeAccents(option.label.toLowerCase()).indexOf(filterValue) !== -1);
    }

    removeAccents = (str) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    displayFn = (option) => (option && option.label) ? option.label : '';

    getAge(birthDate) {
        var today = new Date();
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    dateChange = (event: any) => {
        const date = event.target.value;
        this.form.controls.a4FechaNacimientoBeneficiario.setValue(date);
        const age = this.getAge(date);
        this.form.controls.a4EdadBeneficiario.setValue(age);
    }
}
